import { MapPin, Clock, Phone, Mail, MessageCircle } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { AGENCY, waLink, DEFAULT_WA_MESSAGE } from "@/config";

export const LocationSection = () => (
  <section id="contato" data-testid="location-section" className="bg-ivory py-20 lg:py-32">
    <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.35em] text-gold-bronze mb-5">
          Endereço &amp; Atendimento
        </p>
        <h2
          data-testid="location-title"
          className="font-serif text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight leading-snug text-navy max-w-2xl"
        >
          Visite nosso escritório ou fale conosco{" "}
          <em className="italic text-gold-bronze">de onde estiver.</em>
        </h2>
      </Reveal>

      <div className="mt-14 grid lg:grid-cols-2 gap-8 items-stretch">
        <Reveal>
          <div className="h-full bg-navy grain relative overflow-hidden rounded-3xl p-8 sm:p-12 flex flex-col justify-between">
            <div className="relative z-10 space-y-8">
              <div className="flex items-start gap-4">
                <span className="w-12 h-12 rounded-full bg-gold/15 border border-gold/30 flex items-center justify-center shrink-0">
                  <MapPin className="w-5 h-5 text-gold" />
                </span>
                <div>
                  <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-ivory/50 mb-1">
                    Endereço
                  </p>
                  <p data-testid="location-address" className="text-ivory font-medium text-lg leading-snug">
                    {AGENCY.address}
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <span className="w-12 h-12 rounded-full bg-gold/15 border border-gold/30 flex items-center justify-center shrink-0">
                  <Clock className="w-5 h-5 text-gold" />
                </span>
                <div>
                  <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-ivory/50 mb-1">
                    Horário de funcionamento
                  </p>
                  <p data-testid="location-hours" className="text-ivory font-medium text-lg leading-snug">
                    {AGENCY.hours}
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <span className="w-12 h-12 rounded-full bg-gold/15 border border-gold/30 flex items-center justify-center shrink-0">
                  <Phone className="w-5 h-5 text-gold" />
                </span>
                <div>
                  <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-ivory/50 mb-1">
                    Telefones
                  </p>
                  <p data-testid="location-phones" className="text-ivory font-medium text-lg leading-snug">
                    {AGENCY.phoneDisplay}
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <span className="w-12 h-12 rounded-full bg-gold/15 border border-gold/30 flex items-center justify-center shrink-0">
                  <Mail className="w-5 h-5 text-gold" />
                </span>
                <div>
                  <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-ivory/50 mb-1">
                    E-mail
                  </p>
                  <p data-testid="location-email" className="text-ivory font-medium text-lg leading-snug">
                    {AGENCY.email}
                  </p>
                </div>
              </div>
            </div>
            <a
              href={waLink(DEFAULT_WA_MESSAGE)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="location-whatsapp-cta"
              className="relative z-10 mt-10 inline-flex items-center justify-center gap-2 bg-gold text-navy font-bold px-8 py-4 rounded-full hover:bg-gold-light hover:-translate-y-0.5 transition-all duration-300 shadow-[0_12px_30px_rgba(212,175,55,0.35)]"
            >
              <MessageCircle className="w-5 h-5" />
              Chamar no WhatsApp
            </a>
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="h-full min-h-[380px] rounded-3xl overflow-hidden border border-navy/10 shadow-xl">
            <iframe
              title="Mapa da A.S.F Viagens"
              data-testid="location-map"
              src="https://maps.google.com/maps?q=R.%20Ant%C3%B4nio%20Maria%20Coelho%2C%20236%2C%20Centro%20Norte%2C%20Cuiab%C3%A1%2C%20MT&t=&z=16&ie=UTF8&iwloc=&output=embed"
              className="w-full h-full min-h-[380px]"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
